import { render, staticRenderFns } from "./RouterSpanField.vue?vue&type=template&id=6ec4f646"
import script from "./RouterSpanField.vue?vue&type=script&lang=js"
export * from "./RouterSpanField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports